import React from 'react'
import Grid from '@material-ui/core/Grid'
import { useDispatch, useSelector } from 'react-redux'
import { selectors as loadMenuDataSelectors } from '../selectors/loadMenuDataSelectors'
import { makeStyles } from '@material-ui/styles'
import Box from '@material-ui/core/Box'
import { returnToMenu, selectTagProduct } from '../actions/digitalMenuActions'
import CardMedia from '@material-ui/core/CardMedia'
import NumberFormat from 'react-number-format'
import Card from '@material-ui/core/Card'
import { tagsConstants } from '../constants/tagsConstants'
import DigitalMenuScreen from './DigitalMenuScreen'

const useStyles = makeStyles(() => ({
  tabs: {
    marginTop: '20px',
    marginLeft: '0 10px',
    marginRight: '0 10px',
  },
  dataContent: {
    width: 'auto',
    marginTop: '20px',
    marginLeft: '20px',
    marginRight: '20px',
  },
  spacer: {
    marginTop: '30px',
  },
  tagTitle: {
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  price: {
    marginTop: '20px',
    textTransform: 'uppercase',
  },
  productName: {
    color: '#808080'
  },
  productDescription: {
    color: '#888888'
  },
  productImageCard: {
    display: 'block',
    height: 140,
    width: 140
  },
  productImage: {
    height: '100%',
    width: '100%',
    objectFit: 'cover'
  },
  productSeparator: {
    marginTop: '20px',
    marginBottom: '20px',
    border: '1px solid #F2F2F2',
  }
}))


const TagDetails = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const tag = props.match.params[1].replaceAll('/', '')
  const tagProducts = useSelector(loadMenuDataSelectors.getTagProducts(tag))
  const colors = useSelector(loadMenuDataSelectors.getColors)
  const storeCode = useSelector(loadMenuDataSelectors.getStoreCode)

  const tagTitle = (tag !== null && tag === tagsConstants.FEATURED) ? 'Destaques' : 'Promoções'

  const handleBackButtonClick = () => {
    dispatch(returnToMenu(storeCode))
  }

  const handleProductClick = (product) => () => {
    dispatch(selectTagProduct(tag, product, storeCode))
  }

  const renderProductList = (products) => {
    return products?.map(product => {
      return <Grid key={`product-${product.productCode}`} item xs={12}>
        <Grid container>
          <Grid item xs={12}>
            <Grid container spacing={2} alignItems="center" onClick={handleProductClick(product)}>
              <Grid item xs={7}>
                <Grid container>
                  <Grid item xs={12}>
                    <Box fontSize={24} className={classes.productName} fontWeight="fontWeightBold">
                      {product.menu.title}
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box fontSize={20} className={classes.productDescription}>
                      {product.menu.listDescription}
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      fontSize={22}
                      fontWeight="fontWeightBold"
                      className={classes.price}
                      style={{ color: colors.primary }}
                    >
                      <NumberFormat
                        value={product.price}
                        displayType={'text'}
                        decimalSeparator=","
                        decimalScale={2}
                        fixedDecimalScale={2}
                        prefix={'R$'}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={5}>
                <Grid container>
                  <Grid item xs={12}>
                    {product.imgUrl &&
                    <Card
                      className={classes.productImageCard}
                    >
                      <CardMedia
                        className={classes.productImage}
                        image={product.imgUrl}
                        title={product.menu.title}
                      />
                    </Card>
                    }
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <hr className={classes.productSeparator}/>
          </Grid>
        </Grid>
      </Grid>
    })
  }

  return (
    <DigitalMenuScreen error={!tag} handleBackButtonClick={handleBackButtonClick} {...props}>
      <Grid item xs={12}>
        <Grid container className={classes.dataContent}>
          <Grid item xs={12}>
            <Box
              fontSize={30}
              fontWeight="fontWeightBold"
              className={classes.tagTitle}
              style={{ color: colors.primary }}
            >
              {tagTitle}
            </Box>
          </Grid>
          {tagProducts && <Grid item xs={12} className={classes.spacer}>
            <Grid container>
              {renderProductList(tagProducts)}
            </Grid>
          </Grid>}
        </Grid>
      </Grid>
    </DigitalMenuScreen>
  )
}

export default TagDetails
